import type { ArchitectStage, StageCapability } from '../auth/api';

type StageUser = { isRoot?: boolean; stage_access?: Partial<Record<ArchitectStage, StageCapability>> } | null | undefined;
const confined = new Set(['architect:use', 'architect:generate', 'architect:estimate', 'architect:pricing', 'feedback:submit', 'feedback:view']);

/** Server capabilities are authoritative. Role fallback only supports an older
 * server with no capability payload; an explicit false never falls through. */
export function stageAccess(user: StageUser, permissions: readonly string[], stage: ArchitectStage): StageCapability {
  if (user?.isRoot) return { view: true, edit: true, approve: true, configured: !!user.stage_access?.[stage]?.configured, edit_client_document: true };
  if (!user || !permissions.includes('architect:use')) return { view: false, edit: false, approve: false, configured: false };
  if (user.stage_access) return user.stage_access[stage] ?? { view: false, edit: false, approve: false, configured: true };
  const developer = permissions.some(permission => !confined.has(permission));
  const generator = developer || permissions.includes('architect:generate');
  const estimator = developer || permissions.includes('architect:estimate');
  const edit = stage === 'pricing' ? permissions.includes('architect:pricing') : stage === 'estimate' ? estimator : generator;
  return { view: stage === 'architecture' || edit, edit, approve: edit, configured: false, edit_client_document: false };
}
